// 1. Create the Skeleton component
const LandingMarqueeRowLoadingSkeleton = () => {
  // Create an array of 10 items to fill most screen widths
  const skeletonItems = Array.from({ length: 10 });

  return (
    <div className="w-[100%] flex flex-row gap-4 overflow-hidden relative">
      {skeletonItems.map((_, index) => (
        <div
          key={`skeleton-${index}`}
          className="min-w-[174px] h-[104px] bg-gray-200 animate-pulse rounded-[8px]"
        />
      ))}
    </div>
  );
};

export default LandingMarqueeRowLoadingSkeleton;
